import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "2e20963f-e305-472b-9f6d-af72f81c18cf", content: "Yes, significantly better.", options: {} },
  {
    id: "4a6feccd-645e-4c76-a59f-8e0b6012127b",
    content: "Sometimes, and if there is an</br>improvement, it is fairly small. ",
    options: {},
  },
  { id: "b01df56d-a13a-4704-9cdc-83f66a46b805", content: "No, never.", options: {} },
];

export const task: Task = {
  id: "28e0ee2e-5089-4674-a6ac-3cdf8d291c05",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    columns: 1,
    isMultiple: false,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["4a6feccd-645e-4c76-a59f-8e0b6012127b"],
};
